import React, { Fragment, useState } from 'react';
import { Dialog } from '@headlessui/react';
import { Transition } from '@headlessui/react';
import { LegacyButton } from 'apps/sigma2-ui/src/components/ui/LegacyButton';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { LegacyButtonVariant } from 'apps/sigma2-ui/src/components/ui/Buttons';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';
import { convertTranslatedContentToReactNode } from 'apps/sigma2-ui/src/lib/hooks/useTranslation';

export const ButtonWithConfirmation = ({
  onClick,
  buttonTranslatedContent,
  confirmationTranslatedContent,
}: {
  onClick: () => void;
  buttonTranslatedContent: TranslatedContent;
  confirmationTranslatedContent: TranslatedContent;
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        behavior={{
          type: 'onClick',
          onClick: () => setOpen(true),
        }}
        text={convertTranslatedContentToReactNode(buttonTranslatedContent)}
      />

      <Transition appear show={open} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-overlay"
          onClose={() => setOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-12px transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Are you sure?
                  </Dialog.Title>
                  <div className="mt-2">
                    <S2Typography
                      variant={'body-6'}
                      translatedContent={confirmationTranslatedContent}
                    />
                  </div>

                  <div className="mt-4">
                    <LegacyButton
                      variant={LegacyButtonVariant.PRIMARY_LIGHT}
                      onClick={() => {
                        setOpen(false);
                        onClick();
                      }}
                      className="mt-4"
                    >
                      Confirm
                    </LegacyButton>

                    <LegacyButton
                      variant={LegacyButtonVariant.PRIMARY_LIGHT}
                      onClick={() => setOpen(false)}
                      className="mt-4 ml-4"
                    >
                      Cancel
                    </LegacyButton>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
